/*
 * SIJL - eigen gedrag bovenop het Horizon-thema.
 * Geladen vanuit layout/theme.liquid.
 *
 * Drie onderdelen, allemaal alleen actief op bonbon-productpagina's:
 *   1. Totaal aantal bonbons bij de aantalkiezer
 *   2. Warmweermelding boven de drempel
 *   3. Configurator-UX: heldere knoptekst, opgeschoonde statusregel en een
 *      naam die op het kaartje past
 *
 * Alle drie bepalen zelf of ze op de juiste pagina staan. Staat het element
 * er niet, dan gebeurt er niets - geen foutmelding, geen leeg kader.
 *
 * De sectie kan ook een zwevende samenvatting tonen als er een element met
 * id 'sticky-order-bar' klaarstaat. Dat maken we bewust niet aan: op mobiel
 * nam het te veel van het scherm in en op desktop voegde het weinig toe.
 */

(function () {
  'use strict';

  var WEER_DREMPEL = 24;
  var WEER_BRON = 'https://api.open-meteo.com/v1/forecast?latitude=52.9925&longitude=6.5642&current=temperature_2m';

  /**
   * Leest het aantal bonbons uit de producttitel op de pagina.
   * Levert 0 op als dit geen bonbondoos is.
   */
  function leesDoosgrootte() {
    var main = document.querySelector('main[data-template^="product"]');
    if (!main) return 0;

    var titel = document.querySelector('.sijl-title') || document.querySelector('h1');
    if (!titel) return 0;

    var tekst = titel.textContent || '';
    if (!/stuks/i.test(tekst)) return 0;

    var match = tekst.match(/\b(10|15|24|35)\b/);
    return match ? parseInt(match[1], 10) : 0;
  }

  /**
   * Toont "Samen X bonbons" zodra er meer dan een doos wordt besteld.
   */
  function totaalAantal(doosgrootte) {
    var input = document.querySelector('.sijl-quantity-input');
    if (!input) return;

    var blok = input.closest('.sijl-quantity-block') || input.parentElement;
    if (!blok || blok.querySelector('.sijl-box-total')) return;

    var regel = document.createElement('p');
    regel.className = 'sijl-box-total';
    blok.appendChild(regel);

    function bijwerken() {
      var aantal = parseInt(input.value, 10);
      if (!aantal || aantal < 1) aantal = 1;

      if (aantal > 1) {
        regel.textContent = 'Samen ' + (aantal * doosgrootte) + ' bonbons';
        regel.style.display = '';
      } else {
        regel.textContent = '';
        regel.style.display = 'none';
      }
    }

    input.addEventListener('input', bijwerken);
    input.addEventListener('change', bijwerken);
    document.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('.sijl-quantity-btn')) {
        setTimeout(bijwerken, 40);
      }
    });

    bijwerken();
  }

  /**
   * Toont de warmweermelding onder de verzendbalk.
   */
  function toonWeermelding(graden) {
    var anker = document.querySelector('.sijl-shipment-bar')
      || document.querySelector('.sijl-buy-buttons-wrapper');
    if (!anker || !anker.parentNode) return;
    if (document.querySelector('.sijl-weather')) return;

    var kader = document.createElement('div');
    kader.className = 'sijl-weather';
    kader.setAttribute('role', 'status');

    var icoon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    icoon.setAttribute('viewBox', '0 0 24 24');
    icoon.setAttribute('fill', 'none');
    icoon.setAttribute('stroke', 'currentColor');
    icoon.setAttribute('stroke-width', '1.7');
    icoon.setAttribute('stroke-linecap', 'round');
    icoon.setAttribute('aria-hidden', 'true');
    icoon.innerHTML = '<circle cx="12" cy="12" r="4"></circle>'
      + '<path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4"></path>';
    kader.appendChild(icoon);

    var tekst = document.createElement('span');
    var kop = document.createElement('strong');
    kop.textContent = 'Het is warm in Assen (' + Math.round(graden) + ' °C).';
    tekst.appendChild(kop);
    tekst.appendChild(document.createTextNode(
      ' We wachten met verzenden tot het koeler is, zodat je bonbons perfect aankomen. Afhalen kan gewoon.'
    ));
    kader.appendChild(tekst);

    anker.parentNode.insertBefore(kader, anker.nextSibling);
  }

  function weercheck() {
    if (!window.fetch) return;

    // De bonbonconfigurator heeft een eigen warmweermelding, met een ruimere
    // controle: het maximum van drie dagen in plaats van de temperatuur van nu.
    // Staat die op de pagina, dan laten we die het werk doen - anders krijgt
    // de klant twee meldingen over hetzelfde.
    if (document.getElementById('sijl-warmte-melding')) return;

    fetch(WEER_BRON)
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        var t = d && d.current && d.current.temperature_2m;
        if (typeof t === 'number' && t >= WEER_DREMPEL) toonWeermelding(t);
      })
      .catch(function () {});
  }

  function start() {
    var doosgrootte = leesDoosgrootte();
    if (!doosgrootte) return;

    totaalAantal(doosgrootte);
    weercheck();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/*
 * 3. Configurator-UX
 *
 * Leest alleen bestaande state uit en past tekst aan. De rekenlogica,
 * de winkelwagenknop en de regelitem-eigenschappen blijven volledig van
 * sections/sijl-bonbon-buy-box.liquid.
 *
 * Vier dingen:
 *   - een klasse op de wikkel als aanknopingspunt voor de opmaak
 *   - de tekst op de uitgeschakelde knop wordt "Nog X bonbons kiezen" in
 *     plaats van "Voeg bonbons toe om toe te voegen aan winkelwagen".
 *     Zodra de doos vol is schrijft de sectie zelf de tekst; die laten we staan.
 *   - de statusregel wordt opgeschoond: de sectie zet er "Nog 8 te gaan - of
 *     vul de rest aan" op een regel. In de nieuwe indeling staat de stand
 *     links en de knop rechts, dus de bullet en het "of" kunnen weg.
 *   - een lange naam op het kaartje krimpt tot hij binnen het kaartje past.
 */

(function () {
  'use strict';

  function init() {
    var sys = document.getElementById('bonbon-order-system');
    if (!sys || sys.dataset.sijlUx === '1') return;
    sys.dataset.sijlUx = '1';

    var atc = document.getElementById('sijl-main-atc');

    if (sys.parentElement) sys.parentElement.classList.add('sijl-cfg-wide');

    function num(el) {
      if (!el) return 0;
      var n = parseInt(String(el.textContent).replace(/\D/g, ''), 10);
      return isNaN(n) ? 0 : n;
    }

    // Alleen opschonen als er iets te schonen valt, anders blijft de
    // MutationObserver zichzelf aan de gang houden.
    function statusOpschonen() {
      var regel = sys.querySelector('.js-ui-status-text');
      if (regel) {
        for (var i = 0; i < regel.childNodes.length; i++) {
          var n = regel.childNodes[i];
          if (n.nodeType !== 3) continue;
          var schoon = n.nodeValue.replace(/[\s ]*[•·][\s ]*$/, '');
          if (schoon !== n.nodeValue) n.nodeValue = schoon;
        }
      }

      var knop = sys.querySelector('.sticky-surprise-link');
      if (knop) {
        var t = knop.textContent.trim();
        if (/^of\s+/i.test(t)) {
          t = t.replace(/^of\s+/i, '');
          knop.textContent = t.charAt(0).toUpperCase() + t.slice(1);
        }
      }
    }

    /*
     * De naam op de achterkant van het doosje staat op een regel zonder
     * afbreken, en zijn lettergrootte hangt aan de maat van het kaartje
     * (zie 7g in sijl-custom.css). Een korte naam past daardoor altijd,
     * maar een lange naam wordt breder dan het kaartje en verdween tegen
     * de zijkanten - het kaartje knipt af wat eruit steekt.
     *
     * Hieronder wordt zo'n naam precies zo ver verkleind dat hij past.
     * De opmaak blijft de baas: we meten met de waarde uit de stylesheet
     * en zetten alleen een kleinere maat als het echt niet past. Onder
     * 45 procent stoppen we; wordt de naam dan nog te breed, dan is hij
     * zo lang dat verkleinen ook niet meer helpt.
     *
     * De regel in de stylesheet staat op !important (nodig tegen de
     * inline-stijlen van de sectie), en daar wint een gewone inline-maat
     * het niet van. Vandaar setProperty met dezelfde prioriteit.
     */
    var naamStand = '';

    function naamPassend() {
      var namen = document.querySelectorAll('.sijl-box-back-name');
      if (!namen.length) return;

      // Niets doen zolang naam en kaartbreedte hetzelfde zijn gebleven.
      var stand = '';
      for (var i = 0; i < namen.length; i++) {
        var k = namen[i].closest('.sijl-flip-back');
        stand += namen[i].textContent + '@' + (k ? k.clientWidth : 0) + ';';
      }
      if (stand === naamStand) return;
      naamStand = stand;

      for (var j = 0; j < namen.length; j++) {
        var naam = namen[j];
        var kaart = naam.closest('.sijl-flip-back');
        if (!kaart) continue;

        naam.style.removeProperty('font-size');

        var kcs = window.getComputedStyle(kaart);
        var ruimte = kaart.clientWidth
          - parseFloat(kcs.paddingLeft) - parseFloat(kcs.paddingRight);
        if (!(ruimte > 0)) continue;

        // Het kaartje is een kolom met gecentreerde items, dus de alinea
        // is precies zo breed als de tekst erin.
        var breed = naam.getBoundingClientRect().width;
        if (!breed || breed <= ruimte) continue;

        var basis = parseFloat(window.getComputedStyle(naam).fontSize);
        if (!basis) continue;

        var factor = Math.max((ruimte / breed) * 0.98, 0.45);
        naam.style.setProperty(
          'font-size', (basis * factor).toFixed(1) + 'px', 'important'
        );
      }
    }

    function naamOpnieuw() {
      naamStand = '';
      naamPassend();
    }

    function sync() {
      var total = num(document.getElementById('total-selected'));
      var limit = num(document.getElementById('box-limit'));
      var left = Math.max(limit - total, 0);

      sys.classList.toggle('sijl-cfg-full', limit > 0 && total >= limit);

      if (atc && atc.disabled && left > 0) {
        var want = left === 1 ? 'Nog 1 bonbon kiezen' : 'Nog ' + left + ' bonbons kiezen';
        if (atc.textContent.trim() !== want) atc.textContent = want;
      }

      statusOpschonen();
      naamPassend();
    }

    var obs = new MutationObserver(sync);
    obs.observe(sys, { subtree: true, childList: true, characterData: true });

    if (atc) {
      obs.observe(atc, {
        subtree: true,
        childList: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['disabled']
      });
    }

    // Bij het draaien van een telefoon of het verslepen van een venster
    // verandert de kaartbreedte, en daarmee de ruimte voor de naam.
    var timer = null;
    window.addEventListener('resize', function () {
      clearTimeout(timer);
      timer = setTimeout(naamOpnieuw, 150);
    });

    // Het handschrift is een webfont; zolang dat laadt meten we de
    // vervangende letter en komen we te ruim of te krap uit.
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(naamOpnieuw).catch(function () {});
    }

    sync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();

/*
 * 4. Bonbons verslepen in de doos
 *
 * Sleep een gevuld vakje naar een ander vakje: is dat leeg, dan verhuist de
 * bonbon; zit er al een bonbon, dan wisselen de twee om. Met de muis en met
 * een vinger.
 *
 * Wat er in welk vakje zit weet alleen de sectie zelf
 * (sections/sijl-bonbon-buy-box.liquid); die lijst staat in een afgesloten
 * closure en is van hieruit niet te lezen. De sectie biedt er een handeling
 * voor aan - window.SijlBonbons.moveSlot(van, naar) - en die verplaatst,
 * tekent het doosje opnieuw en werkt de regels bij die meegaan naar de
 * winkelwagen. Hier gebeurt alleen het slepen zelf.
 *
 * Op een telefoon moet je een bonbon eerst even vasthouden. Zou hij meteen
 * loskomen, dan kon je niet meer langs het doosje scrollen: elke veeg over de
 * vakjes zou een bonbon meenemen in plaats van de pagina te verplaatsen.
 */

(function () {
  'use strict';

  var HOUD_MS = 180; // zo lang stilhouden voordat een vinger een bonbon oppakt
  var SPELING = 6;   // px die de muis mag bewegen voordat het slepen begint
  var VEEG = 10;     // px: beweegt de vinger meer, dan wil hij scrollen

  var HINT = 'Sleep een bonbon naar een ander vakje. Zit daar al een bonbon, dan wisselen ze om.';

  var bezig = false;   // is er nu iets onderweg?
  var bron = null;     // het vakje waar de bonbon vandaan komt
  var bronIndex = -1;
  var doel = null;     // het vakje waar hij nu boven hangt
  var geest = null;    // het bonbonnetje dat met de aanwijzer meegaat
  var wachter = null;  // timer van het vasthouden
  var aanwijzer = null;
  var vinger = false;
  var startX = 0;
  var startY = 0;
  var slikKlik = false;

  /*
   * De sectie is de baas over de inhoud van de doos. Ontbreekt die handeling,
   * dan draait hier een oudere versie van de sectie en doen we niets - geen
   * half werkend slepen en ook geen uitleg onder de doos.
   */
  function doos() {
    var api = window.SijlBonbons;
    return api && typeof api.moveSlot === 'function' ? api : null;
  }

  function vakjeVan(el) {
    if (!el || !el.closest) return null;
    var slot = el.closest('.box-slot');
    return slot && slot.closest('.js-ui-visual-grid') ? slot : null;
  }

  function indexVan(slot) {
    var n = slot ? parseInt(slot.getAttribute('data-slot-index'), 10) : NaN;
    return isNaN(n) ? -1 : n;
  }

  function geestMaken() {
    var maat = bron.getBoundingClientRect();
    var foto = bron.querySelector('img');

    geest = document.createElement('div');
    geest.className = vinger
      ? 'sijl-sleep-geest sijl-sleep-geest--vinger'
      : 'sijl-sleep-geest';
    geest.style.width = maat.width + 'px';
    geest.style.height = maat.height + 'px';

    if (foto) {
      var kopie = document.createElement('img');
      kopie.src = foto.src;
      kopie.alt = '';
      geest.appendChild(kopie);
    }

    document.body.appendChild(geest);
  }

  function geestNaar(x, y) {
    if (!geest) return;
    geest.style.left = x + 'px';
    geest.style.top = y + 'px';
  }

  function doelZoeken(x, y) {
    // De geest vangt geen aanwijzer (pointer-events: none), dus hier zit
    // altijd het vakje eronder.
    var slot = vakjeVan(document.elementFromPoint(x, y));
    if (!slot || slot === bron) return null;

    // Alleen binnen hetzelfde doosje; een tweede balk heeft een eigen raster.
    if (slot.closest('.js-ui-visual-grid') !== bron.closest('.js-ui-visual-grid')) return null;

    return slot;
  }

  function doelZetten(slot) {
    if (doel === slot) return;
    if (doel) doel.classList.remove('sijl-sleep-doel');
    doel = slot;
    if (doel) doel.classList.add('sijl-sleep-doel');
  }

  function oppakken() {
    if (bezig || !bron) return;

    bezig = true;
    clearTimeout(wachter);
    wachter = null;

    geestMaken();
    bron.classList.add('sijl-sleep-bron');
    document.body.classList.add('sijl-sleept');

    if (navigator.vibrate) {
      try { navigator.vibrate(8); } catch (e) {}
    }
  }

  /* Alles terugzetten. Levert op of er daadwerkelijk iets onderweg was. */
  function loslaten() {
    var liep = bezig;

    clearTimeout(wachter);
    wachter = null;

    if (geest && geest.parentNode) geest.parentNode.removeChild(geest);
    geest = null;

    if (bron) bron.classList.remove('sijl-sleep-bron');
    doelZetten(null);
    document.body.classList.remove('sijl-sleept');

    bron = null;
    bronIndex = -1;
    aanwijzer = null;
    bezig = false;

    return liep;
  }

  document.addEventListener('pointerdown', function (e) {
    if (bron || !doos()) return;
    if (e.pointerType === 'mouse' && e.button !== 0) return;

    var slot = vakjeVan(e.target);
    if (!slot || !slot.classList.contains('filled')) return;

    // Het kruisje hoort bij de sectie: dat verwijdert, dat sleept niet.
    if (e.target.closest && e.target.closest('.slot-remove-btn')) return;

    var idx = indexVan(slot);
    if (idx < 0) return;

    // Sommige browsers pakken bij een lange druk de foto zelf op ("afbeelding
    // bewaren"). Het doorzichtige laagje uit 7h vangt dat af; dit is de tweede
    // sluiting, voor browsers die dat laagje niet meenemen in de hittest.
    var fotos = slot.querySelectorAll('img');
    for (var f = 0; f < fotos.length; f++) fotos[f].draggable = false;

    bron = slot;
    bronIndex = idx;
    aanwijzer = e.pointerId;
    vinger = e.pointerType !== 'mouse';
    startX = e.clientX;
    startY = e.clientY;

    if (vinger) {
      wachter = setTimeout(function () {
        oppakken();
        geestNaar(startX, startY);
      }, HOUD_MS);
    }
  });

  document.addEventListener('pointermove', function (e) {
    if (!bron || e.pointerId !== aanwijzer) return;

    var dx = e.clientX - startX;
    var dy = e.clientY - startY;

    if (!bezig) {
      if (vinger) {
        // Nog aan het vasthouden: beweegt de vinger, dan wil hij scrollen.
        if (Math.abs(dx) > VEEG || Math.abs(dy) > VEEG) loslaten();
        return;
      }

      if (Math.abs(dx) < SPELING && Math.abs(dy) < SPELING) return;
      oppakken();
    }

    geestNaar(e.clientX, e.clientY);
    doelZetten(doelZoeken(e.clientX, e.clientY));
  });

  document.addEventListener('pointerup', function (e) {
    if (!bron || e.pointerId !== aanwijzer) return;

    var naarIndex = bezig ? indexVan(doelZoeken(e.clientX, e.clientY)) : -1;
    var van = bronIndex;
    var liep = loslaten();

    if (!liep || naarIndex < 0 || naarIndex === van) return;

    var api = doos();
    if (api) api.moveSlot(van, naarIndex);

    // Na het loslaten volgt nog een klik op het vakje eronder; die zou daar
    // het actieve vakje van maken. Bij een sleepbeweging hoort dat niet.
    slikKlik = true;
    setTimeout(function () { slikKlik = false; }, 400);
  });

  document.addEventListener('pointercancel', function (e) {
    if (!bron || e.pointerId !== aanwijzer) return;
    loslaten();
  });

  document.addEventListener('click', function (e) {
    if (!slikKlik) return;
    slikKlik = false;
    e.stopPropagation();
    e.preventDefault();
  }, true);

  // Zolang er iets onderweg is mag de pagina niet meescrollen.
  document.addEventListener('touchmove', function (e) {
    if (bezig) e.preventDefault();
  }, { passive: false });

  // Geen vasthoudmenu op een vakje: daar valt niets te kopieren of te bewaren,
  // en op een telefoon zit dat menu het slepen juist in de weg.
  document.addEventListener('contextmenu', function (e) {
    if (bezig || vakjeVan(e.target)) e.preventDefault();
  });

  document.addEventListener('dragstart', function (e) {
    if (vakjeVan(e.target)) e.preventDefault();
  });

  /*
   * Het regeltje onder het doosje. Het komt er alleen als er ook echt
   * gesleept kan worden; wanneer het zichtbaar is regelt 7h in
   * sijl-custom.css - niet bij een lege doos en niet bij een omgedraaid
   * doosje.
   */
  function hintPlaatsen() {
    if (!doos()) return false;

    var houders = document.querySelectorAll('.js-ui-visual-container');
    if (!houders.length) return false;

    for (var i = 0; i < houders.length; i++) {
      draaiknopPlaatsen(houders[i]);

      if (houders[i].querySelector('.sijl-sleep-hint')) continue;

      var regel = document.createElement('p');
      regel.className = 'sijl-sleep-hint';
      regel.textContent = HINT;
      houders[i].appendChild(regel);
    }

    return true;
  }

  /*
   * Zodra de doos vol is draait de sectie het doosje om naar de cadeaukant.
   * Mooi moment, maar de vakjes zijn dan weg en er valt niets meer te
   * herschikken. Met dit knopje draai je hem terug naar de indeling en weer
   * vooruit naar de cadeaukant.
   *
   * De sectie blijft bepalen wanneer er omgedraaid wordt; wij zetten er
   * alleen de klasse 'sijl-terug' overheen die die draai tijdelijk opheft
   * (7i in sijl-custom.css). Haalt de klant daarna een bonbon uit de doos,
   * dan neemt de sectie 'is-flipped' weg en ruimen wij onze klasse mee op -
   * anders zou de cadeaukant wegblijven zodra de doos opnieuw vol is.
   */
  function knopTekst(knop, kaart) {
    var tekst = kaart.classList.contains('sijl-terug')
      ? 'Bekijk de cadeaukant'
      : 'Bekijk de indeling';

    // Niets schrijven als er niets verandert: elke schrijfactie is een
    // wijziging die de waarnemer hieronder weer wakker maakt.
    if (knop.getAttribute('aria-label') === tekst) return;

    knop.setAttribute('aria-label', tekst);
    knop.setAttribute('title', tekst);

    var label = knop.querySelector('.sijl-draaiknop__tekst');
    if (label) label.textContent = tekst;
  }

  function draaiknopPlaatsen(houder) {
    var kaart = houder.querySelector('.sijl-flip');
    if (!kaart || !kaart.parentNode) return;
    if (houder.querySelector('.sijl-draairij')) return;

    var knop = document.createElement('button');
    knop.type = 'button';
    knop.className = 'sijl-draaiknop';
    knop.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">'
      + '<path d="M3 12a9 9 0 0 1 9-9c3.4 0 6.3 1.9 7.8 4.7"/>'
      + '<path d="M20 3v4.7h-4.7"/>'
      + '<path d="M21 12a9 9 0 0 1-9 9c-3.4 0-6.3-1.9-7.8-4.7"/>'
      + '<path d="M4 21v-4.7h4.7"/>'
      + '</svg><span class="sijl-draaiknop__tekst"></span>';

    knopTekst(knop, kaart);

    knop.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      kaart.classList.toggle('sijl-terug');
      knopTekst(knop, kaart);
    });

    var rij = document.createElement('div');
    rij.className = 'sijl-draairij';
    rij.appendChild(knop);
    kaart.parentNode.insertBefore(rij, kaart.nextSibling);

    /*
     * Let op bij het opruimen hieronder: classList.remove() schrijft het
     * class-attribuut ook opnieuw als die klasse er helemaal niet stond, en
     * de browser telt dat als een wijziging. Zonder de controle erbij maakt
     * deze waarnemer zichzelf daarmee eindeloos opnieuw wakker en staat de
     * hele pagina stil - precies op het moment dat de sectie 'is-flipped'
     * weghaalt, dus zodra er een bonbon uit een volle doos gaat. Alleen
     * schrijven als er echt iets te veranderen valt.
     */
    new MutationObserver(function () {
      if (kaart.classList.contains('sijl-terug') && !kaart.classList.contains('is-flipped')) {
        kaart.classList.remove('sijl-terug');
      }

      knopTekst(knop, kaart);
    }).observe(kaart, { attributes: true, attributeFilter: ['class'] });
  }

  var waarnemer = null;

  function start() {
    var sys = document.getElementById('bonbon-order-system');
    if (!sys) return;

    if (waarnemer) {
      waarnemer.disconnect();
      waarnemer = null;
    }

    if (hintPlaatsen()) return;

    // De samenvattingsbalk wordt door de sectie zelf opgebouwd, dus het
    // doosje staat er niet altijd meteen.
    waarnemer = new MutationObserver(function () {
      if (!hintPlaatsen()) return;
      waarnemer.disconnect();
      waarnemer = null;
    });

    waarnemer.observe(sys, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', start);
})();

/*
 * 5. Nu open
 *
 * Een klein statusregeltje: staat de deur in Assen op dit moment open?
 *
 * De tijden komen uit de structured data die snippets/sijl-seo.liquid al op de
 * pagina zet - de gewone weekopeningstijden en de dagen dat we dicht zijn. Zo
 * staat er maar op een plek wanneer we open zijn: pas je die aan, dan verandert
 * dit mee en leest Google exact hetzelfde. Er wordt hier niets hardgecodeerd.
 *
 * Twee plekken, allebei bewust klein:
 *   - op de computer een stipje met een woordje achter BEZOEK ONS in het menu,
 *     en alleen als we open zijn; dicht hoeft daar niet te staan
 *   - op de telefoon een regel onderaan, onder de voettekstkolommen, ook als
 *     we dicht zijn - dan weet je meteen wanneer je wel terecht kunt
 * Staat BEZOEK ONS in het menu, dan blijft de regel onderaan weg; zo staat het
 * er nooit twee keer.
 *
 * Het staat er alleen waar die gegevens staan: de homepage en het
 * openingstijden-artikel.
 */

(function () {
  'use strict';

  var TIJDZONE = 'Europe/Amsterdam';

  var DAGEN = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

  var DAGNAAM = {
    Sunday: 'zondag', Monday: 'maandag', Tuesday: 'dinsdag', Wednesday: 'woensdag',
    Thursday: 'donderdag', Friday: 'vrijdag', Saturday: 'zaterdag'
  };

  function twee(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function naarMinuten(tijd) {
    var m = /^(\d{1,2}):(\d{2})/.exec(String(tijd || ''));
    if (!m) return null;
    return parseInt(m[1], 10) * 60 + parseInt(m[2], 10);
  }

  function naarKlok(minuten) {
    var u = Math.floor(minuten / 60);
    var r = minuten % 60;
    return u + ':' + twee(r);
  }

  // schema.org schrijft een dag als "Monday" of als "https://schema.org/Monday".
  function dagVan(waarde) {
    return String(waarde || '').split('/').pop();
  }

  function datumSleutel(d) {
    return d.jaar + '-' + twee(d.maand) + '-' + twee(d.dag);
  }

  /*
   * Rekenen met dagen doen we in UTC op een kale datum. Zou je er uren bij
   * optellen in de lokale tijd, dan gaat het mis in het weekend dat de klok
   * verspringt.
   */
  function datumPlus(basis, dagen) {
    var d = new Date(Date.UTC(basis.jaar, basis.maand - 1, basis.dag + dagen));
    return {
      jaar: d.getUTCFullYear(),
      maand: d.getUTCMonth() + 1,
      dag: d.getUTCDate(),
      weekdag: d.getUTCDay()
    };
  }

  /* Openingstijden uit de structured data op deze pagina. */
  function gegevens() {
    var week = {};
    var bijzonder = {};
    var scripts = document.querySelectorAll('script[type="application/ld+json"]');

    for (var i = 0; i < scripts.length; i++) {
      var data;
      try {
        data = JSON.parse(scripts[i].textContent);
      } catch (e) {
        continue;
      }

      var lijst = Array.isArray(data) ? data : [data];

      for (var j = 0; j < lijst.length; j++) {
        var item = lijst[j];
        if (!item || typeof item !== 'object') continue;

        leesWeek(week, item.openingHoursSpecification);
        leesBijzonder(bijzonder, item.specialOpeningHoursSpecification);
      }
    }

    return { week: week, bijzonder: bijzonder };
  }

  function leesWeek(week, spec) {
    if (!spec) return;
    if (!Array.isArray(spec)) spec = [spec];

    for (var k = 0; k < spec.length; k++) {
      var van = naarMinuten(spec[k].opens);
      var tot = naarMinuten(spec[k].closes);
      if (van === null || tot === null) continue;

      var dagen = spec[k].dayOfWeek;
      if (!Array.isArray(dagen)) dagen = [dagen];

      for (var d = 0; d < dagen.length; d++) {
        var naam = dagVan(dagen[d]);
        if (DAGEN.indexOf(naam) === -1) continue;
        if (!week[naam]) week[naam] = [];
        week[naam].push({ van: van, tot: tot });
      }
    }
  }

  /*
   * De uitzonderingen: feestdagen en andere losse dagen. Een dag die erin
   * staat met dezelfde begin- en eindtijd is een dag dat we dicht zijn; dat is
   * hoe schema.org een sluiting noteert. De dag komt dan met een lege lijst in
   * de tabel, en dat is iets anders dan een dag die er niet in staat: die
   * laatste valt terug op de gewone weektijden.
   */
  function leesBijzonder(bijzonder, spec) {
    if (!spec) return;
    if (!Array.isArray(spec)) spec = [spec];

    for (var k = 0; k < spec.length; k++) {
      var vanaf = leesDatum(spec[k].validFrom);
      if (!vanaf) continue;

      var tm = leesDatum(spec[k].validThrough) || vanaf;
      var van = naarMinuten(spec[k].opens);
      var tot = naarMinuten(spec[k].closes);

      var dag = vanaf;
      var slot = datumSleutel(tm);

      // De grens is er voor het geval een datum niet klopt; anders zou een
      // verkeerde validThrough deze lus laten doorlopen.
      for (var stap = 0; stap < 400; stap++) {
        var sleutel = datumSleutel(dag);
        if (!bijzonder[sleutel]) bijzonder[sleutel] = [];

        if (van !== null && tot !== null && van !== tot) {
          bijzonder[sleutel].push({ van: van, tot: tot });
        }

        if (sleutel === slot) break;
        dag = datumPlus(dag, 1);
      }
    }
  }

  function leesDatum(waarde) {
    var m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(waarde || ''));
    if (!m) return null;

    return {
      jaar: parseInt(m[1], 10),
      maand: parseInt(m[2], 10),
      dag: parseInt(m[3], 10)
    };
  }

  /*
   * De klok van Assen, niet die van de bezoeker. Iemand die vanuit Spanje
   * kijkt hoort te lezen of de winkel hier open is, niet daar.
   */
  function nuInAssen() {
    var deel = {};

    try {
      new Intl.DateTimeFormat('en-CA', {
        timeZone: TIJDZONE,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        weekday: 'long',
        hour: '2-digit',
        minute: '2-digit',
        hourCycle: 'h23'
      }).formatToParts(new Date()).forEach(function (p) { deel[p.type] = p.value; });
    } catch (e) {
      return null;
    }

    var jaar = parseInt(deel.year, 10);
    var maand = parseInt(deel.month, 10);
    var dag = parseInt(deel.day, 10);
    var uur = parseInt(deel.hour, 10);
    var min = parseInt(deel.minute, 10);

    if (isNaN(jaar) || isNaN(maand) || isNaN(dag) || isNaN(uur) || isNaN(min)) return null;
    if (DAGEN.indexOf(deel.weekday) === -1) return null;

    return {
      jaar: jaar,
      maand: maand,
      dag: dag,
      weekdag: DAGEN.indexOf(deel.weekday),
      minuten: (uur % 24) * 60 + min
    };
  }

  /* De tijden van een bepaalde dag: een uitzondering gaat voor de weektijden. */
  function urenVoor(data, dag) {
    var sleutel = datumSleutel(dag);
    var lijst;

    if (Object.prototype.hasOwnProperty.call(data.bijzonder, sleutel)) {
      lijst = data.bijzonder[sleutel];
    } else {
      lijst = data.week[DAGEN[dag.weekdag]] || [];
    }

    return lijst.slice().sort(function (a, b) { return a.van - b.van; });
  }

  function stand(data) {
    var nu = nuInAssen();
    if (!nu) return null;

    for (var d = 0; d < 8; d++) {
      var dag = datumPlus(nu, d);
      var lijst = urenVoor(data, dag);

      for (var i = 0; i < lijst.length; i++) {
        var blok = lijst[i];

        if (d === 0) {
          if (nu.minuten >= blok.van && nu.minuten < blok.tot) {
            return { open: true, kort: 'open', lang: 'Nu open tot ' + naarKlok(blok.tot) };
          }
          if (blok.van <= nu.minuten) continue;
        }

        var wanneer = d === 0 ? 'vandaag' : (d === 1 ? 'morgen' : DAGNAAM[DAGEN[dag.weekdag]]);

        return {
          open: false,
          kort: 'gesloten',
          lang: 'Nu gesloten · ' + wanneer + ' vanaf ' + naarKlok(blok.van)
        };
      }
    }

    return { open: false, kort: 'gesloten', lang: 'Nu gesloten' };
  }

  function stip() {
    var s = document.createElement('span');
    s.className = 'sijl-nu__stip';
    s.setAttribute('aria-hidden', 'true');
    return s;
  }

  /*
   * Alleen het menu-item BEZOEK ONS zelf. Dezelfde pagina wordt ook gelinkt
   * vanuit het uitklapmenu, vanuit de voettekst en vanuit losse zinnen in de
   * tekst; daar hoort dit stipje niet. We herkennen het item aan zijn eigen
   * opschrift en niet aan een klassenaam van het thema, want die kan bij een
   * update veranderen.
   */
  function bezoekLinks() {
    var alle = document.querySelectorAll(
      'a[href*="bezoek-sijl-assen"], a[href*="openingstijden-locatie"]'
    );
    var uit = [];

    for (var i = 0; i < alle.length; i++) {
      var link = alle[i];

      // Al eens goedgekeurd: het opschrift bevat nu ook het stipje.
      if (link.getAttribute('data-sijl-nu') === '1') {
        uit.push(link);
        continue;
      }

      if (!link.closest || !link.closest('[class*="header-menu"], [id*="ss_header"], header')) continue;
      if (link.textContent.replace(/\s+/g, ' ').trim().toLowerCase() !== 'bezoek ons') continue;

      link.setAttribute('data-sijl-nu', '1');
      uit.push(link);
    }

    return uit;
  }

  var menuLinks = [];
  var voetRegel = null;

  function menuPlaatsen(st) {
    var links = bezoekLinks();

    for (var i = 0; i < links.length; i++) {
      var link = links[i];
      var badge = link.querySelector('.sijl-nu--menu');

      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'sijl-nu sijl-nu--menu';

        var kort = document.createElement('span');
        kort.className = 'sijl-nu__kort';
        kort.setAttribute('aria-hidden', 'true');

        var voor = document.createElement('span');
        voor.className = 'visually-hidden';

        badge.appendChild(stip());
        badge.appendChild(kort);
        badge.appendChild(voor);
        link.appendChild(badge);

        menuLinks.push(link);
      }

      // Dicht laten we in het menu weg; de stylesheet verbergt data-open="0".
      badge.setAttribute('data-open', st.open ? '1' : '0');
      badge.setAttribute('title', st.lang);
      badge.querySelector('.sijl-nu__kort').textContent = st.kort;
      badge.querySelector('.visually-hidden').textContent = st.open ? st.lang : '';
    }
  }

  function voetAnker() {
    var nav = document.querySelector('[id*="sijl_footer_nav"] .section');
    if (nav) return nav;

    var util = document.querySelector('[id*="footer_utilities"]');
    if (util && util.parentNode) return util.parentNode;

    return null;
  }

  function voetPlaatsen(st) {
    if (!voetRegel) {
      var anker = voetAnker();
      if (!anker) return;

      voetRegel = document.createElement('p');
      voetRegel.className = 'sijl-nu-regel';

      var link = document.createElement('a');
      link.className = 'sijl-nu';
      link.href = '/blogs/informatie/bezoek-sijl-assen-openingstijden-locatie-reviews';
      link.appendChild(stip());
      link.appendChild(document.createElement('span'));

      voetRegel.appendChild(link);
      anker.appendChild(voetRegel);
    }

    var a = voetRegel.querySelector('a');
    a.setAttribute('data-open', st.open ? '1' : '0');
    a.lastChild.textContent = st.lang;
  }

  /*
   * "Staat het op het scherm" is lastiger dan het lijkt. Het dichtgeklapte
   * mobiele menu heeft gewoon afmetingen en een offsetParent; het is onzichtbaar
   * doordat het op opacity: 0 staat. Zou je daar alleen naar de afmetingen
   * kijken, dan denk je dat het in beeld staat terwijl niemand het ziet - en
   * dan verdwijnt ook de regel onderaan. Vandaar checkVisibility, met een
   * terugvaloptie voor oudere browsers.
   */
  function echtZichtbaar(el) {
    if (typeof el.checkVisibility === 'function') {
      if (!el.checkVisibility({ checkOpacity: true, checkVisibilityCSS: true })) return false;
    } else if (!el.offsetParent) {
      return false;
    }

    var b = el.getBoundingClientRect();
    return b.width > 0 && b.height > 0 && b.right > 0 && b.left < (window.innerWidth || 0);
  }

  /*
   * Kijkt naar het menu-item en niet naar het stipje zelf: als we dicht zijn
   * staat dat stipje er bewust niet, en dan hoort de regel onderaan ook niet
   * ineens op de computer op te duiken.
   */
  function dubbelingWeghalen() {
    if (!voetRegel) return;

    var inBeeld = false;

    for (var i = 0; i < menuLinks.length; i++) {
      if (echtZichtbaar(menuLinks[i])) {
        inBeeld = true;
        break;
      }
    }

    voetRegel.classList.toggle('sijl-nu-regel--verborgen', inBeeld);
  }

  function bijwerken() {
    var st = stand(gegevens());
    if (!st) return;

    menuPlaatsen(st);
    voetPlaatsen(st);
    dubbelingWeghalen();
  }

  function start() {
    // Geen openingstijden op deze pagina: dan hoort hier ook niets te staan.
    var data = gegevens();
    var heeftTijden = false;
    for (var k in data.week) { if (data.week.hasOwnProperty(k)) { heeftTijden = true; break; } }
    if (!heeftTijden) return;

    bijwerken();

    // Het thema bouwt zijn menu pas na het laden af; pas daarna is te zien
    // welke van de twee plekken echt in beeld staat.
    window.addEventListener('load', dubbelingWeghalen);
    setTimeout(dubbelingWeghalen, 800);

    // Iemand kan de pagina over sluitingstijd heen open laten staan.
    setInterval(bijwerken, 60000);

    var timer = null;
    window.addEventListener('resize', function () {
      clearTimeout(timer);
      timer = setTimeout(dubbelingWeghalen, 150);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/*
 * 6. Zoeken vanuit de header
 *
 * Het zoekvenster van het thema deed niets: de component verwacht een knop met
 * ref="resetButton" die niet in de opmaak staat, struikelt daarover bij het
 * opstarten en koppelt zich daarna nooit aan het invoerveld. Wat je zag waren
 * de vier voorbeeldproducten die er bij het laden al in stonden - wat je ook
 * intikte. Dit vervangt dat door een eigen paneel.
 *
 * Het paneel klapt uit de menubalk zoals BONBONS, KOFFIE en de rest. Dat gaat
 * vanzelf goed: we lenen de klassenamen van een bestaand menu-item, zodat ons
 * item dezelfde vorm, achtergrond en beweging krijgt als de buren. Die namen
 * bevatten een sectienummer dat bij een thema-update verandert - door ze uit
 * de pagina te lezen in plaats van ze op te schrijven, blijft dit kloppen.
 *
 * Er wordt op twee plekken gezocht:
 *   - de winkel zelf, via /search/suggest.json (producten, artikelen, pagina's)
 *   - de bonbonsmaken, uit snippets/sijl-zoek-data.liquid. Die staan als
 *     metaobject in de winkel en zijn voor Shopify's zoekfunctie onzichtbaar,
 *     dus "pistache" levert daar niets op. Hier wel.
 *
 * Op de telefoon staat hetzelfde veld bovenaan het uitklapmenu.
 */

(function () {
  'use strict';

  var MINIMUM = 2;   // vanaf hoeveel letters we gaan zoeken
  var WACHT = 220;   // ms stil zijn voordat we de winkel bevragen

  var TIPS = ['bonbondoos', 'koffiebonen', 'matcha', 'cadeau'];

  var smaken = null;
  var panelen = [];
  var teller = 0;

  function zichtbaar(el) {
    if (!el) return false;
    if (typeof el.checkVisibility === 'function') {
      if (!el.checkVisibility({ checkOpacity: true, checkVisibilityCSS: true })) return false;
    } else if (!el.offsetParent) {
      return false;
    }
    var b = el.getBoundingClientRect();
    return b.width > 0 && b.height > 0;
  }

  function smakenLezen() {
    if (smaken) return smaken;

    var el = document.getElementById('sijl-smaken');
    smaken = [];

    if (el) {
      try {
        var lijst = JSON.parse(el.textContent);
        if (Array.isArray(lijst)) smaken = lijst;
      } catch (e) {
        smaken = [];
      }
    }

    return smaken;
  }

  /*
   * De smaakwoorden staan in enkelvoud en in een eigen vorm: "nootachtig",
   * "koekje", "fruitig". Iemand tikt "noten" of "citroen". Dat vangen we hier
   * op. Mis je een woord, zet het er dan gewoon bij - links het woord dat
   * iemand intikt, rechts het smaakwoord dat erbij hoort.
   */
  var SYNONIEMEN = {
    noot: 'nootachtig',
    noten: 'nootachtig',
    notig: 'nootachtig',
    fruit: 'fruitig',
    vruchtig: 'fruitig',
    koekjes: 'koekje',
    biscuit: 'koekje',
    citroen: 'citrus',
    limoen: 'citrus',
    room: 'romig',
    cocktails: 'cocktail',
    kruiden: 'kruidig',
    kruidnagel: 'kruidig'
  };

  function smaakTreffers(term) {
    var t = term.toLowerCase();
    var termen = [t];
    if (SYNONIEMEN[t]) termen.push(SYNONIEMEN[t]);

    var uit = [];
    var lijst = smakenLezen();

    for (var i = 0; i < lijst.length && uit.length < 6; i++) {
      var s = lijst[i];
      var woorden = Array.isArray(s.smaak) ? s.smaak.join(' ') : String(s.smaak || '');
      var hooi = (s.naam + ' ' + (s.chocolade || '') + ' ' + woorden).toLowerCase();

      for (var j = 0; j < termen.length; j++) {
        if (hooi.indexOf(termen[j]) !== -1) {
          uit.push(s);
          break;
        }
      }
    }

    return uit;
  }

  function winkelZoeken(term) {
    var url = '/search/suggest.json?q=' + encodeURIComponent(term)
      + '&resources[type]=product,article,page'
      + '&resources[limit]=5';

    return fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  /* ------------------------------------------------------------------ bouw */

  function el(tag, klasse, tekst) {
    var e = document.createElement(tag);
    if (klasse) e.className = klasse;
    if (tekst != null) e.textContent = tekst;
    return e;
  }

  function kolom(titel) {
    var k = el('div', 'sijl-zoek__kolom');
    k.appendChild(el('p', 'sijl-zoek__kop', titel));
    var lijst = el('ul', 'sijl-zoek__lijst');
    k.appendChild(lijst);
    k.lijst = lijst;
    return k;
  }

  function regel(href, naam, bij, foto) {
    var li = el('li', 'sijl-zoek__regel');
    var a = el('a', 'sijl-zoek__link');
    a.href = href;

    var beeld = el('span', 'sijl-zoek__foto');
    if (foto) {
      var img = el('img');
      img.src = foto;
      img.alt = '';
      img.loading = 'lazy';
      beeld.appendChild(img);
    }
    a.appendChild(beeld);

    var tekst = el('span', 'sijl-zoek__tekst');
    tekst.appendChild(el('span', 'sijl-zoek__naam', naam));
    if (bij) tekst.appendChild(el('span', 'sijl-zoek__bij', bij));
    a.appendChild(tekst);

    li.appendChild(a);
    return li;
  }

  function inhoudBouwen() {
    var wikkel = el('div', 'sijl-zoek');

    var veld = el('div', 'sijl-zoek__veld');

    var loep = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    loep.setAttribute('viewBox', '0 0 24 24');
    loep.setAttribute('class', 'sijl-zoek__loep');
    loep.setAttribute('aria-hidden', 'true');
    loep.innerHTML = '<circle cx="11" cy="11" r="7"></circle><path d="M20 20l-3.5-3.5"></path>';
    veld.appendChild(loep);

    var invoer = el('input', 'sijl-zoek__invoer');
    invoer.type = 'search';
    invoer.name = 'q';
    invoer.autocomplete = 'off';
    invoer.placeholder = 'Zoek een smaak, boon of verhaal';
    invoer.setAttribute('aria-label', 'Zoeken bij SIJL');
    veld.appendChild(invoer);

    var wissen = el('button', 'sijl-zoek__wissen');
    wissen.type = 'button';
    wissen.setAttribute('aria-label', 'Zoekterm wissen');
    wissen.textContent = '×';
    veld.appendChild(wissen);

    wikkel.appendChild(veld);

    var uitslag = el('div', 'sijl-zoek__uitslag');
    wikkel.appendChild(uitslag);

    var voet = el('div', 'sijl-zoek__voet');
    var alles = el('a', 'sijl-zoek__alles');
    alles.href = '/search';
    voet.appendChild(alles);
    wikkel.appendChild(voet);

    return { wikkel: wikkel, invoer: invoer, wissen: wissen, uitslag: uitslag, voet: voet, alles: alles };
  }

  function leegTonen(p) {
    p.uitslag.innerHTML = '';
    p.voet.classList.add('sijl-zoek__voet--weg');

    var tips = el('div', 'sijl-zoek__tips');
    tips.appendChild(el('span', 'sijl-zoek__kop', 'Waar zoek je naar?'));

    TIPS.forEach(function (woord) {
      var b = el('button', 'sijl-zoek__tip', woord);
      b.type = 'button';
      b.addEventListener('click', function (e) {
        /*
         * Tegenhouden dat deze klik verderop als "buiten het paneel geklikt"
         * wordt gezien. Zoeken tekent de uitslag opnieuw en haalt dit knopje
         * daarmee uit de pagina; tegen de tijd dat de klik bij het document
         * aankomt zit het nergens meer in, en dan sloot het hele paneel.
         */
        e.stopPropagation();
        p.invoer.value = woord;
        p.invoer.focus();
        zoek(p);
      });
      tips.appendChild(b);
    });

    p.uitslag.appendChild(tips);
  }

  function nietsTonen(p, term) {
    p.uitslag.innerHTML = '';
    p.uitslag.appendChild(el('p', 'sijl-zoek__niets', 'Niets gevonden voor “' + term + '”.'));
    p.voet.classList.remove('sijl-zoek__voet--weg');
    p.alles.textContent = 'Toch alles doorzoeken op “' + term + '”';
    p.alles.href = '/search?q=' + encodeURIComponent(term);
  }

  function uitslagTonen(p, term, smaakLijst, data) {
    var res = (data && data.resources && data.resources.results) || {};
    var producten = res.products || [];
    var artikelen = (res.articles || []).concat(res.pages || []);

    if (!smaakLijst.length && !producten.length && !artikelen.length) {
      nietsTonen(p, term);
      return;
    }

    p.uitslag.innerHTML = '';

    if (smaakLijst.length) {
      var k1 = kolom('Bonbonsmaken');
      smaakLijst.forEach(function (s) {
        var bij = Array.isArray(s.smaak) ? s.smaak.slice(0, 3).join(', ') : '';
        k1.lijst.appendChild(regel(s.url, s.naam, bij, s.foto));
      });
      p.uitslag.appendChild(k1);
    }

    if (producten.length) {
      var k2 = kolom('In de winkel');
      producten.forEach(function (pr) {
        var foto = pr.featured_image && pr.featured_image.url ? pr.featured_image.url : (pr.image || '');
        k2.lijst.appendChild(regel(pr.url, pr.title, prijs(pr.price), foto));
      });
      p.uitslag.appendChild(k2);
    }

    if (artikelen.length) {
      var k3 = kolom('Om te lezen');
      artikelen.forEach(function (a) {
        k3.lijst.appendChild(regel(a.url, a.title, '', (a.image || '')));
      });
      p.uitslag.appendChild(k3);
    }

    p.voet.classList.remove('sijl-zoek__voet--weg');
    p.alles.textContent = 'Alle resultaten voor “' + term + '”';
    p.alles.href = '/search?q=' + encodeURIComponent(term);
  }

  /* Shopify geeft de prijs als kaal getal terug; wij zetten er een euro bij. */
  function prijs(waarde) {
    if (waarde === null || waarde === undefined || waarde === '') return '';
    var n = Number(String(waarde).replace(',', '.'));
    if (isNaN(n)) return String(waarde);
    return '\u20ac ' + n.toFixed(2).replace('.', ',');
  }

  function zoek(p) {
    var term = p.invoer.value.trim();

    p.wikkel.classList.toggle('sijl-zoek--gevuld', term !== '');

    if (term.length < MINIMUM) {
      leegTonen(p);
      return;
    }

    var beurt = ++teller;
    var smaakLijst = smaakTreffers(term);

    // De smaken staan al in de pagina, dus die kunnen meteen. De winkel doen
    // we erbij zodra het antwoord binnen is.
    uitslagTonen(p, term, smaakLijst, null);

    winkelZoeken(term).then(function (data) {
      if (beurt !== teller) return;           // er is alweer verder getypt
      if (p.invoer.value.trim() !== term) return;
      uitslagTonen(p, term, smaakLijst, data);
    });
  }

  function paneelKoppelen(p) {
    var timer = null;

    p.invoer.addEventListener('input', function () {
      clearTimeout(timer);
      timer = setTimeout(function () { zoek(p); }, WACHT);
    });

    p.invoer.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        var term = p.invoer.value.trim();
        if (term) {
          e.preventDefault();
          window.location.href = '/search?q=' + encodeURIComponent(term);
        }
      }
      if (e.key === 'Escape') {
        if (p.invoer.value) {
          p.invoer.value = '';
          zoek(p);
        } else if (p.sluit) {
          p.sluit();
        }
      }
    });

    p.wissen.addEventListener('click', function () {
      p.invoer.value = '';
      p.invoer.focus();
      zoek(p);
    });

    leegTonen(p);
    panelen.push(p);
  }

  /* ------------------------------------------- knopje naast de winkelwagen */

  /*
   * De zichtbare menubalk. Het uitklapmenu van de telefoon gebruikt dezelfde
   * klassenaam, dus die sluiten we hier uit - anders belandt het zoekveld
   * onderaan die lade in plaats van in de balk.
   */
  function balkLijst() {
    var lijsten = document.querySelectorAll('[class*="header-menu-list"]');

    for (var i = 0; i < lijsten.length; i++) {
      if (lijsten[i].closest('[class*="header-menu-mobile"]')) continue;
      if (zichtbaar(lijsten[i])) return lijsten[i];
    }

    return null;
  }

  function inIconenrij() {
    var lijst = balkLijst();
    if (!lijst || !lijst.parentElement) return false;

    var rechts = document.querySelector('[class*="header-right"]');
    if (!rechts || !zichtbaar(rechts)) return false;
    if (rechts.querySelector('.sijl-zoek-knop')) return true;

    // Van een bestaand uitklapmenu lenen we de klassen, zodat ons paneel
    // dezelfde vorm, breedte en achtergrond krijgt als dat van BONBONS.
    var voorbeeld = lijst.querySelector('[class*="header-submenu"]');
    if (!voorbeeld || !voorbeeld.firstElementChild) return false;

    var paneel = document.createElement('div');
    paneel.className = voorbeeld.className + ' sijl-zoek-paneel';

    var binnen = document.createElement('div');
    binnen.className = voorbeeld.firstElementChild.className;
    paneel.appendChild(binnen);

    var p = inhoudBouwen();
    binnen.appendChild(p.wikkel);

    // Naast de menubalk hangen, want daar rekent het thema de plek van een
    // uitklapmenu tegenaan.
    lijst.parentElement.appendChild(paneel);

    /*
     * Een link en geen knop, met de klassen van het accounticoon ernaast. Het
     * thema kleurt zijn icoontjes per staat - donker op de lichte header, licht
     * op de doorzichtige - en die regels gelden voor de lijnen in het vakje om
     * het tekeningetje. Daarom zit onze loep in net zo'n vakje en is het
     * dezelfde tekening als de loep van het thema zelf: zonder dat vakje kreeg
     * hij de linkkleur en stond hij oranje en dikker tussen de andere iconen.
     */
    var account = rechts.querySelector('[class*="header-account"]');
    var vakje = rechts.querySelector('[class*="header-account-icon"], [class*="header-cart-icon"]');
    var knop = document.createElement('a');
    knop.className = (account ? account.className + ' ' : '') + 'sijl-zoek-knop';
    knop.href = '/search';
    knop.setAttribute('aria-label', 'Zoeken');
    knop.setAttribute('aria-expanded', 'false');
    knop.innerHTML = '<span' + (vakje ? ' class="' + vakje.className + '"' : '') + '>'
      + '<svg viewBox="-0.5 -0.5 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" height="16" width="16" aria-hidden="true" focusable="false">'
      + '<path d="m11.27 11.27 3.02 3.02" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"></path>'
      + '<path d="M0.72 6.75c0 3.33 2.7 6.03 6.03 6.03s6.03-2.7 6.03-6.03S10.08 0.72 6.75 0.72 0.72 3.42 0.72 6.75Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"></path>'
      + '</svg></span>';

    // Links van het accounticoon.
    rechts.insertBefore(knop, rechts.firstChild);

    /*
     * De header is doorzichtig boven de pagina en wordt licht zodra er een
     * uitklapmenu openstaat; dat regelt het thema met de klasse 'menu-open'.
     * Ons paneel is voor het thema geen menu, dus zonder dit zakte de header
     * terug naar zwart terwijl het zoekpaneel gewoon open bleef staan.
     */
    var kop = (function () {
      var e = lijst;
      while (e && e !== document.body) {
        if (/header-/.test(String(e.className)) &&
            (e.classList.contains('transparent') || e.classList.contains('fixed') ||
             e.classList.contains('onscroll') || e.classList.contains('menu-open'))) return e;
        e = e.parentElement;
      }
      return null;
    })();

    // Het thema gebruikt twee klassen samen: 'menu-open' en 'open'. Alleen de
    // eerste laat de doorzichtige header nog zwart; met allebei wordt hij licht.
    var KOPKLASSEN = ['menu-open', 'open'];

    var open = function () {
      paneel.classList.add('sijl-zoek-open');
      if (kop) {
        for (var i = 0; i < KOPKLASSEN.length; i++) kop.classList.add(KOPKLASSEN[i]);
      }
      knop.setAttribute('aria-expanded', 'true');
      p.invoer.focus();
    };

    p.sluit = function () {
      paneel.classList.remove('sijl-zoek-open');

      // Alleen weghalen als het thema zelf geen menu openheeft staan.
      if (kop && !lijst.querySelector('.active')) {
        for (var j = 0; j < KOPKLASSEN.length; j++) kop.classList.remove(KOPKLASSEN[j]);
      }

      knop.setAttribute('aria-expanded', 'false');
      p.invoer.blur();
    };

    knop.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (paneel.classList.contains('sijl-zoek-open')) {
        p.sluit();
      } else {
        open();
      }
    });

    document.addEventListener('click', function (e) {
      // Alleen als het zoekpaneel openstaat. Sluiten haalt ook 'open' van de
      // header af, en dat is dezelfde klasse waarmee het thema de lade op de
      // telefoon opent: wie een tablet van liggend naar staand draaide, kreeg
      // het menu daarna niet meer open en kon niet meer scrollen.
      if (!paneel.classList.contains('sijl-zoek-open')) return;
      if (!paneel.contains(e.target) && !knop.contains(e.target) && e.target !== knop) p.sluit();
    });

    paneelKoppelen(p);
    return true;
  }

  /* ------------------------------------------------ veld in het mobiele menu */

  function inMobielMenu() {
    var binnen = document.querySelector('[class*="header-menu-mobile-inner"]');
    if (!binnen || binnen.querySelector('.sijl-zoek')) return false;

    var p = inhoudBouwen();
    p.wikkel.classList.add('sijl-zoek--mobiel');
    binnen.insertBefore(p.wikkel, binnen.firstChild);

    paneelKoppelen(p);
    return true;
  }

  function start() {
    if (!document.getElementById('sijl-smaken') && !document.querySelector('[class*="header-menu-list"]')) return;

    var klaar = inIconenrij();
    var klaarMobiel = inMobielMenu();

    // De header wordt na het laden nog omgebouwd, dus als er nu nog niets
    // stond proberen we het zo nog een keer.
    if (!klaar || !klaarMobiel) {
      setTimeout(function () { inIconenrij(); inMobielMenu(); }, 800);
    }

    window.addEventListener('resize', function () {
      // Wisselt het scherm van de balk naar het uitklapmenu, dan hoort het
      // zoekveld mee te verhuizen.
      inIconenrij();
      inMobielMenu();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/*
 * 7. Header: mobiel menu en kleurstand
 *
 * De header is een ingekochte sectie (SS - Header #17); wat je in de sectie
 * zelf verandert, raak je bij een update weer kwijt. Daarom staat dit hier.
 * Het menu van het thema blijft zijn werk doen; dit legt er vier dingen
 * overheen:
 *   - namen voor schermlezers: de hamburger, het logo, het account en de
 *     winkelwagen zijn plaatjes zonder tekst, dus daar klonk alleen 'knop'
 *     of 'link'
 *   - de regels in de lade: het thema klapt een submenu alleen open via het
 *     plusje van 16 px en het woord ernaast was een link naar de categorie.
 *     Nu doet de hele regel het
 *   - een loepje naast de winkelwagen dat de lade opent met de cursor in het
 *     zoekveld
 *   - de kleurstand: zodra je niet bovenaan de pagina staat is de balk licht,
 *     ook na het sluiten van het menu
 *
 * De opmaak erbij staat onderaan sijl-custom.css.
 */

(function () {
  'use strict';

  function burgerKnop() {
    return document.querySelector('button[class*="header-menu-burger-"]');
  }

  /*
   * Het buitenste element van de header; daar zet het thema de klasse 'open'
   * op zodra de lade openstaat. Alle klassen van de header eindigen op het
   * sectienummer en dat lezen we van de hamburger af.
   */
  var kopEl = null;

  function kop() {
    if (kopEl && kopEl.isConnected) return kopEl;

    var burger = burgerKnop();
    var m = burger ? /header-menu-burger-(\S+)/.exec(String(burger.className)) : null;
    kopEl = m ? document.querySelector('[class~="header-' + m[1] + '"]') : null;
    return kopEl;
  }

  /*
   * De kleurstand van de zwevende header: bovenaan de pagina donker en
   * doorschijnend, daaronder licht. Het thema wisselt dat tijdens het scrollen,
   * maar zet de lichte stand niet terug als je halverwege de pagina het menu
   * sluit, en slaat hem over als je in één keer onderaan belandt. Dan stond er
   * een donkere, doorschijnende balk met witte iconen over de tekst.
   */
  function kleurstand() {
    var header = kop();
    if (!header || !header.classList.contains('transparent')) return;
    if (window.scrollY <= 0 || header.classList.contains('open') || header.classList.contains('onscroll')) return;

    header.classList.add('onscroll');
    header.classList.remove('top');
  }

  function naam(el, tekst) {
    if (el && !el.hasAttribute('aria-label')) el.setAttribute('aria-label', tekst);
  }

  /*
   * De teller staat als '(2)' in de link en is voor schermlezers verborgen;
   * het aantal gaat daarom mee in de naam en verandert mee met de teller.
   */
  function wagenNaam(wagen) {
    if (wagen.hasAttribute('data-sijl-naam')) return;
    wagen.setAttribute('data-sijl-naam', '');

    var teller = wagen.querySelector('.cart-count-bubble');

    var zet = function () {
      var m = teller ? /\d+/.exec(teller.textContent || '') : null;
      var n = m ? parseInt(m[0], 10) : -1;
      wagen.setAttribute('aria-label', n < 0 ? 'Winkelwagen' : 'Winkelwagen, ' + (n === 1 ? '1 artikel' : n + ' artikelen'));
    };

    zet();

    if (teller && window.MutationObserver) {
      new MutationObserver(zet).observe(teller, { childList: true, characterData: true, subtree: true });
    }
  }

  function namen() {
    var burger = burgerKnop();
    var header = kop();
    var lade = document.querySelector('div[class*="header-menu-mobile-"]:not([class*="header-menu-mobile-inner-"])');

    if (burger && !burger.hasAttribute('aria-expanded')) {
      burger.setAttribute('aria-label', 'Menu');
      burger.setAttribute('aria-expanded', header && header.classList.contains('open') ? 'true' : 'false');

      if (lade) {
        if (!lade.id) lade.id = 'sijl-mobiel-menu';
        burger.setAttribute('aria-controls', lade.id);
      }

      // Aan 'open' op de header hangt ook de kleurstand: na het sluiten van de
      // lade moet die terug naar licht.
      if (header && window.MutationObserver) {
        new MutationObserver(function () {
          burger.setAttribute('aria-expanded', header.classList.contains('open') ? 'true' : 'false');
          kleurstand();
        }).observe(header, { attributes: true, attributeFilter: ['class'] });
      }
    }

    var logos = document.querySelectorAll('a[class*="header-logo-image-"]');
    for (var i = 0; i < logos.length; i++) naam(logos[i], 'SIJL, naar de homepage');

    var accounts = document.querySelectorAll('[class*="header-right-"] a[class*="header-account-"]');
    for (var j = 0; j < accounts.length; j++) naam(accounts[j], 'Account');

    var wagens = document.querySelectorAll('[class*="header-right-"] a[class*="header-cart-"]');
    for (var k = 0; k < wagens.length; k++) wagenNaam(wagens[k]);
  }

  /*
   * Nu het woord geen link meer is, moet de categorie zelf bereikbaar blijven.
   * Bij KOFFIE staat 'Alle koffiebonen' al in het submenu; waar zo'n regel
   * ontbreekt (BONBONS), komt er een bovenaan.
   */
  function allesLink(woord, submenu) {
    var doel = woord.getAttribute('href');
    var lijst = submenu.querySelector('ul');
    if (!doel || !lijst || lijst.querySelector('.sijl-menu-alles')) return;

    var pad = function (a) { return String(a.pathname || '').replace(/\/+$/, ''); };
    var links = lijst.querySelectorAll('a[href]');

    for (var i = 0; i < links.length; i++) {
      if (pad(links[i]) === pad(woord)) return;
    }

    var li = document.createElement('li');
    li.className = 'sijl-menu-alles';

    var a = document.createElement('a');
    a.href = doel;
    a.textContent = 'Alles in ' + (woord.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();

    li.appendChild(a);
    lijst.insertBefore(li, lijst.firstChild);
  }

  /*
   * De regels in de lade. Het thema hangt het open- en dichtklappen aan het
   * plusje en zet daar de klasse 'active' op; een tik op de rest van de regel
   * geven we aan dat plusje door. Zonder script blijft het woord een gewone
   * link naar de categorie.
   */
  function regels() {
    var wikkels = document.querySelectorAll('[class*="header-menu-mobile-"] [class*="header-menu-link-wrapper-"]');

    for (var i = 0; i < wikkels.length; i++) {
      (function (wikkel, nr) {
        if (wikkel.hasAttribute('data-sijl-regel')) return;

        var plus = wikkel.querySelector('svg[class*="header-menu-link-open-"]');
        var woord = wikkel.firstElementChild;
        var submenu = wikkel.nextElementSibling;
        if (!plus || !woord || woord === plus || !submenu) return;

        wikkel.setAttribute('data-sijl-regel', '');

        if (!submenu.id) submenu.id = 'sijl-submenu-' + (nr + 1);

        // Voor een schermlezer is het woord de knop; het plusje is het teken ervoor.
        woord.setAttribute('role', 'button');
        woord.setAttribute('aria-expanded', plus.classList.contains('active') ? 'true' : 'false');
        woord.setAttribute('aria-controls', submenu.id);
        if (!woord.hasAttribute('href')) woord.setAttribute('tabindex', '0');
        plus.setAttribute('aria-hidden', 'true');

        allesLink(woord, submenu);

        var klap = function () {
          plus.dispatchEvent(new MouseEvent('click', { bubbles: true }));
        };

        wikkel.addEventListener('click', function (e) {
          if (plus.contains(e.target)) return;   // het plusje doet het zelf al
          e.preventDefault();
          klap();
        });

        woord.addEventListener('keydown', function (e) {
          // Enter op een link geeft al een klik; bij een knop hoort de spatiebalk ook te werken.
          if (e.key === ' ' || (e.key === 'Enter' && !woord.hasAttribute('href'))) {
            e.preventDefault();
            klap();
          }
        });

        if (window.MutationObserver) {
          new MutationObserver(function () {
            woord.setAttribute('aria-expanded', plus.classList.contains('active') ? 'true' : 'false');
          }).observe(plus, { attributes: true, attributeFilter: ['class'] });
        }
      })(wikkels[i], i);
    }
  }

  /*
   * Het loepje op de telefoon. Op het grote scherm zet het zoekscript
   * (onderdeel 6) een loepje naast het account; onder 1024 px staat dat niet
   * in beeld. Dit loepje opent de lade en zet de cursor in het zoekveld dat
   * daar bovenin staat. Zonder script, of zonder zoekveld, blijft het een
   * gewone link naar de zoekpagina. De stylesheet toont het alleen onder
   * 1024 px.
   */
  function loepje() {
    var rechts = document.querySelector('[class*="header-right-"]');
    var wagen = rechts ? rechts.querySelector('a[class*="header-cart-"]') : null;
    if (!rechts || !wagen || rechts.querySelector('.sijl-zoek-loepje')) return;

    // De kleur van de iconen regelt het thema per staat van de header, op de
    // klasse van het vakje om het tekeningetje. Die klasse lenen we van het
    // winkelwagenicoon, met 'search' in plaats van 'cart'.
    var vakje = wagen.querySelector('[class*="header-cart-icon-"]');
    var klasse = vakje ? String(vakje.className).replace(/header-cart-icon-/g, 'header-search-icon-') : '';

    var knop = document.createElement('a');
    knop.className = 'sijl-zoek-loepje';
    knop.href = '/search';
    knop.setAttribute('aria-label', 'Zoeken');
    knop.innerHTML = '<span class="' + klasse + '">'
      + '<svg viewBox="-0.5 -0.5 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" height="16" width="16" aria-hidden="true" focusable="false">'
      + '<path d="m11.27 11.27 3.02 3.02" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"></path>'
      + '<path d="M0.72 6.75c0 3.33 2.7 6.03 6.03 6.03s6.03-2.7 6.03-6.03S10.08 0.72 6.75 0.72 0.72 3.42 0.72 6.75Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"></path>'
      + '</svg></span>';

    rechts.insertBefore(knop, wagen);

    knop.addEventListener('click', function (e) {
      var burger = burgerKnop();
      var veld = document.querySelector('[class*="header-menu-mobile-"] .sijl-zoek input');
      if (!burger || !veld) return;

      e.preventDefault();
      e.stopPropagation();

      var header = kop();
      if (header && !header.classList.contains('open')) burger.click();

      // In dezelfde tik, anders opent een telefoon het toetsenbord niet.
      veld.focus();
    });
  }

  function start() {
    namen();
    regels();
    loepje();
    kleurstand();
  }

  window.addEventListener('scroll', kleurstand, { passive: true });
  window.addEventListener('pageshow', kleurstand);

  function eerste() {
    start();

    // De header wordt na het laden nog omgebouwd; wat er dan pas staat, pakken
    // we zo mee. Alle drie slaan over wat ze al gedaan hebben.
    setTimeout(start, 800);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', eerste);
  } else {
    eerste();
  }

  document.addEventListener('shopify:section:load', start);
})();
